import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../services/api';

const SystemSettingsContext = createContext({
  settings: null,
  loading: true,
  refresh: () => {},
});

const DEFAULT_PUBLIC = {
  siteName: 'Liberty',
  contactEmail: '',
  contactPhone: '',
  landing: {
    stores: {
      appStore: { url: '', enabled: true },
      googlePlay: { url: '', enabled: true },
    },
    social: {
      facebook: { url: '', enabled: true },
      instagram: { url: '', enabled: true },
      tiktok: { url: '', enabled: true },
    },
  },
  maintenance: false,
  registrationEnabled: true,
  emailVerificationRequired: true,
  phoneVerificationRequired: true,
  stripeEnabled: true,
  currency: 'TND',
  minPayment: 10,
};

export function SystemSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const response = await api.getPublicSystemSettings();
      if (response?.success && response.data) {
        setSettings(response.data);
      }
    } catch (_) {
      /* garde les derniers paramètres connus */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 60000);
    return () => clearInterval(interval);
  }, [refresh]);

  const value = {
    settings: settings || DEFAULT_PUBLIC,
    loading,
    refresh,
  };

  return (
    <SystemSettingsContext.Provider value={value}>
      {children}
    </SystemSettingsContext.Provider>
  );
}

export function useSystemSettings() {
  return useContext(SystemSettingsContext);
}
